const SMS_STATUS_META = {
  pending: { label: '处理中', tone: 'warning', description: '短信正在提交至运营商。' },
  accepted: { label: '已受理', tone: 'success', description: '短信服务商已接收发送请求。' },
  failed: { label: '发送失败', tone: 'danger', description: '短信未能成功提交。' },
  skipped: { label: '未发送', tone: 'neutral', description: '因通知设置或账号条件未发送。' },
};

const SMS_PURPOSE_LABELS = {
  selection_submitted: '客户提交选片',
  registration_code: '注册验证码',
  password_reset_code: '密码重置验证码',
  login_code: '登录验证码',
};

function getSmsStatusMeta(status) {
  return SMS_STATUS_META[status] || { label: status || '未知', tone: 'neutral', description: '暂无状态说明。' };
}

function getSmsPurposeLabel(purpose) {
  return SMS_PURPOSE_LABELS[purpose] || purpose || '其他短信';
}

function normalizeSmsLogsResponse(payload) {
  return {
    logs: Array.isArray(payload?.logs) ? payload.logs : [],
    total: Math.max(0, Number(payload?.total) || 0),
    page: Math.max(1, Number(payload?.page) || 1),
    totalPages: Math.max(1, Number(payload?.totalPages) || 1),
  };
}

export { getSmsPurposeLabel, getSmsStatusMeta, normalizeSmsLogsResponse };
